module.exports = __webpack_public_path__ + "static/media/ico_lb_right_arrow.35c9b697.svg";